import { render, staticRenderFns } from "./RgCategoryFilter.vue?vue&type=template&id=11fdca58&scoped=true&"
import script from "./RgCategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./RgCategoryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./RgCategoryFilter.vue?vue&type=style&index=0&id=11fdca58&lang=postcss&scoped=true&"
import style1 from "./RgCategoryFilter.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fdca58",
  null
  
)

export default component.exports